import script from "./LoginIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginIndex.vue?vue&type=script&setup=true&lang=js"

import "./LoginIndex.vue?vue&type=style&index=0&id=1702d4ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1702d4ba"]])

export default __exports__